import DOMPurify from 'dompurify';

export const isHtml = (s) => /<\/?[a-z][\s\S]*>/i.test(s || '');
// Keep blank lines from the editor visible: empty paragraphs and trailing line breaks collapse in plain HTML.
const keepBlankLines = (s) => s.replace(/<br[^>]*>(\s*)<\/p>/gi, '<br><br>$1</p>').replace(/<p([^>]*)><\/p>/gi, '<p$1><br></p>');
export const safeHtml = (s) => DOMPurify.sanitize(keepBlankLines(s || ''), { ADD_ATTR: ['target', 'data-align'] });
export const stripHtml = (s) => (isHtml(s) ? (new DOMParser().parseFromString(s.replace(/<\/(p|h[1-6]|li|div|blockquote)>|<br\s*\/?>/gi, ' $&'), 'text/html').body.textContent || '').replace(/\s+/g, ' ').trim() : (s || ''));

const esc = (t) => t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
// Legacy plain-text content -> paragraphs, so old posts open intact in the editor.
export const toEditorHtml = (s) => {
  if (!s) return '';
  if (isHtml(s)) return s;
  const t = s.replace(/\r\n?/g, '\n');
  return t.split(/\n{2,}/).map(p => `<p>${esc(p).replace(/\n/g, '<br>')}</p>`).join('');
};
